import { Component, OnInit } from "@angular/core";
import { FuseConfigService } from "@fuse/services/config.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { environment } from '../../../../environments/environment'

@Component({
    selector: "app-web-login",
    templateUrl: "./web-login.component.html",
    styleUrls: ["./web-login.component.scss"],
})
export class WebLoginComponent implements OnInit {
    countryCode = "+91";
    phoneNumber = "";
    otp = "";
    otpSent = false;
    phoneError = false;
    otpError = false;

    user_id: any = "";
    mobile_no: any = "";

    constructor(
        private _fuseConfigService: FuseConfigService,
        private snackBar: MatSnackBar,
        private router: Router,
        private http: HttpClient
    ) {
        // Hide layout elements
        this._fuseConfigService.config = {
            layout: {
                navbar: { hidden: true },
                toolbar: { hidden: true },
                footer: { hidden: true },
                sidepanel: { hidden: true },
            },
        };
    }

    ngOnInit(): void {
        this.user_id = sessionStorage.getItem("web_user_id");
        this.mobile_no = sessionStorage.getItem("web_mobile");

        if (this.user_id || this.mobile_no) {
            this.router.navigate(["/charger-home"]);
            return;
        }
    }

    validatePhone(): boolean {
        const isValid = /^\d{10}$/.test(this.phoneNumber);
        this.phoneError = !isValid;
        return isValid;
    }

    validateOtp(): boolean {
        const isValid = /^\d{6}$/.test(this.otp);
        this.otpError = !isValid;
        return isValid;
    }

    getOtp() {
        if (!this.validatePhone()) return;

        const payload = { mobile: `${this.phoneNumber}` };

        fetch(
            // "https://cmsapi.vmatic.co.in/api-v3/app/getotp", 
            `${environment.API_URL2}/api-v3/app/getotp`, 
            {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                // Add other headers if needed
            },
            body: JSON.stringify(payload),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                if (data.status) {
                    this.snackBar.open(data.message, "Dismiss", {
                        duration: 5000,
                    });
                    this.otpSent = true;
                }
            })
            .catch((error) => {
                console.error("OTP error:", error);
                this.snackBar.open("Something went wrong.", "Dismiss", {
                    duration: 5000,
                });
            });
    }

    verifyOtp() {
        if (!this.validatePhone() || !this.validateOtp()) return;

        const payload = {
            mobile: this.phoneNumber,
            otp: this.otp,
        };

        // Using fetch() to send POST request
        fetch(
            // "https://cmsapi.vmatic.co.in/api-v2/app/verifyotp", 
            `${environment.API_URL2}/api-v2/app/verifyotp`, 
            {
            method: "POST", // HTTP method
            headers: {
                "Content-Type": "application/json", // Set content type to JSON
            },
            body: JSON.stringify(payload), // Send the data as a JSON string
        })
            .then((response) => response.json()) // Parse the JSON response
            .then((data) => {
                this.snackBar.open(data.message, "Dismiss", {
                    duration: 5000,
                });
                if (data.status) {
                    sessionStorage.setItem("web_user_id", data.data[0].id);
                    sessionStorage.setItem("web_mobile", data.data[0].mobile);

                    // Redirecting to a route using navigate()
                    this.router.navigate(["/charger-home"]);
                }
            })
            .catch((error) => {
                console.error("OTP error:", error);
                this.snackBar.open("Something went wrong.", "Dismiss", {
                    duration: 5000,
                });
            });
    }
}
